/**
 * Green Lodging - Load More Posts Functionality
 * Simple show/hide approach - No API key required!
 */

document.addEventListener('DOMContentLoaded', function() {
    
    const loadMoreBtn = document.getElementById('load-more-btn');
    const postsContainer = document.getElementById('more-posts-list');
    
    if (!loadMoreBtn || !postsContainer) return;
    
    const postsPerClick = 3; // Show 3 more posts each click
    const initialVisible = 4; // First 4 posts are visible (index 0-3)
    let currentVisible = initialVisible;
    
    const allCards = postsContainer.querySelectorAll('.gl-more-posts-card');
    const totalPosts = allCards.length;
    
    // If 4 or fewer posts, hide button
    if (totalPosts <= initialVisible) {
        loadMoreBtn.style.display = 'none';
        return;
    }
    
    loadMoreBtn.addEventListener('click', function() {
        const nextVisible = Math.min(currentVisible + postsPerClick, totalPosts);
        
        // Show next batch of posts
        for (let i = currentVisible; i < nextVisible; i++) {
            const card = allCards[i];
            if (card) {
                card.classList.remove('gl-hidden');
                // Add animation
                setTimeout(() => {
                    card.classList.add('gl-visible');
                }, (i - currentVisible) * 100);
            }
        }
        
        currentVisible = nextVisible;
        
        // Hide button if all posts are visible
        if (currentVisible >= totalPosts) {
            loadMoreBtn.textContent = 'No More Posts';
            loadMoreBtn.disabled = true;
            setTimeout(() => {
                loadMoreBtn.style.display = 'none';
            }, 1000);
        }
    });
});

